import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";
import { SectionHeading, fadeUp } from "@/components/landing/shared";
import { useSiteContent } from "@/context/ContentContext";

export default function StandardVsCustom() {
  const { standard_vs_custom: s } = useSiteContent();
  const customWhen = s.custom_when || [];
  return (
    <section className="relative border-t border-black/[0.08] py-16 md:py-24 lg:py-28">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} intro={s.intro} />

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-40px" }}
            variants={fadeUp}
            className="rounded-2xl border border-black/10 bg-white p-7"
          >
            <span className="inline-flex items-center rounded-full border border-black/10 bg-white px-3 py-1 text-xs text-secondary">
              {s.standard_badge}
            </span>
            <h3 className="mt-5 text-xl font-semibold text-[color:var(--text-primary)]">
              {s.standard_title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-secondary">
              {s.standard_body}
            </p>
            <div className="mt-6 flex items-center gap-2 rounded-lg border border-black/[0.08] bg-black/[0.02] px-4 py-3 text-sm text-tertiary">
              <Minus className="h-4 w-4" />
              {s.standard_note}
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-40px" }}
            variants={fadeUp}
            custom={1}
            className="rounded-2xl border border-emerald-400/25 bg-emerald-600/[0.05] p-7"
          >
            <span className="inline-flex items-center rounded-full border border-emerald-400/30 bg-emerald-600/10 px-3 py-1 text-xs text-emerald-700">
              {s.custom_badge}
            </span>
            <h3 className="mt-5 text-xl font-semibold text-[color:var(--text-primary)]">
              {s.custom_title}
            </h3>
            <ul className="mt-4 space-y-2.5">
              {customWhen.map((c, i) => (
                <li
                  key={`${c}-${i}`}
                  className="flex items-start gap-3 text-sm text-[color:var(--text-primary)]"
                >
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
                  {c}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          variants={fadeUp}
          className="mt-10 max-w-2xl text-lg font-medium leading-relaxed text-[color:var(--text-primary)]"
        >
          {s.closing}
        </motion.p>
      </div>
    </section>
  );
}
